import TypeAheadList from '@app/components/TypeAheadList'
import { MembershipType } from '@app/models/enums'
import { IMembership } from '@app/models/Membership'
import { IUser } from '@app/models/User'
import {
  IGlobalRolesState,
  IGlobalTeamsState,
} from '@app/store/modules/global'
import { bindFunctions } from '@app/utils/class'
import { getRoles, getTeams } from '@app/utils/permissions'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { List } from 'immutable'
import * as React from 'react'

interface IComponentProps {
  onChange: (memberOf: List<IMembership>) => void
  type: MembershipType
  value?: IUser
}

export default class MembershipEditor extends React.PureComponent<
  IComponentProps & IGlobalRolesState & IGlobalTeamsState
> {
  public constructor(props: any) {
    super(props)

    bindFunctions(this)
  }

  public render() {
    let arrayData: any

    if (this.props.type === MembershipType.Team) {
      arrayData = this.props.teams
    } else {
      arrayData = this.props.roles
    }

    return (
      <div>
        <TypeAheadList
          clearInputAfterSelection={true}
          dataSource={arrayData.toArray()}
          value=''
          placeholder={`Type to give the user a ${this.props.type.toLowerCase()}`}
          labelKey='id'
          onChange={this._addMembership}
        />

        {this._renderMemberships()}
      </div>
    )
  }

  private _addMembership(item: any) {
    if (!this.props.value) {
      return
    }

    const memberOf = this.props.value.memberOf.toArray()

    memberOf.push({ authenticatorId: item.id, type: this.props.type })

    this.props.onChange(List(memberOf))
  }

  private _removeMembership(id: string) {
    if (!this.props.value) {
      return
    }

    const memberOf = this.props.value.memberOf.toArray()

    for (let i = 0; i < memberOf.length; i++) {
      if (
        memberOf[i].type === this.props.type &&
        memberOf[i].authenticatorId === id
      ) {
        memberOf.splice(i, 1)
      }
    }
    this.props.onChange(List(memberOf))
  }

  private _renderMemberships() {
    if (this.props.type === MembershipType.Role) {
      const roles = getRoles(this.props.roles, this.props.value).map(
        (item: any) => {
          return (
            <div
              key={item}
              className='d-flex flex-row justify-content-between mt-2'
            >
              <strong>{item.name}</strong>
              <a
                className='text-danger'
                onClick={() => this._removeMembership(item.id)}
              >
                <FontAwesomeIcon icon={['fal', 'trash']} />
              </a>
            </div>
          )
        },
      )

      return <div className='mt-2 ml-2'>{roles}</div>
    } else {
      const teams = getTeams(this.props.teams, this.props.value).map(
        (item: any) => {
          return (
            <div
              key={item}
              className='d-flex flex-row justify-content-between mt-2'
            >
              <strong>{item.name}</strong>
              <a
                className='text-danger'
                onClick={() => this._removeMembership(item.id)}
              >
                <FontAwesomeIcon icon={['fal', 'trash']} />
              </a>
            </div>
          )
        },
      )

      return <div className='mt-2 ml-2'>{teams}</div>
    }
  }
}
